var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMitchatnim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83.87 92.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#93459a;}.cls-3{fill:#8d5ba5;}.cls-4{fill:#231f20;}.cls-4,.cls-5{fill-rule:evenodd;}.cls-5{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.69,
    width: 83.18,
    height: 92.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,45.42c0-7.89,0-15.79,0-23.69C.06,13.45,6.32,8,15.12,8.09c13.31.13,26.45,2,39.66,3.06,2.89.24,5.78.41,8.65.75C70,12.69,75.26,17.77,75.35,24c.19,14.28.23,28.55,0,42.82-.09,5.39-4.71,11.6-12.12,12.2Q47.37,80.3,31.53,81.88c-6.65.66-13.31,1.35-20,.56A13.05,13.05,0,0,1,0,70c-.08-8.2,0-16.4,0-24.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4.4,45.44c0-7.89,0-15.78,0-23.67,0-8.28,5.94-13.72,14.22-13.63,12.54.13,24.91,2,37.36,3.06,2.72.24,5.44.41,8.14.75a12.62,12.62,0,0,1,11.23,12.1c.18,14.26.22,28.53,0,42.79A12.72,12.72,0,0,1,64,79Q49,80.3,34.09,81.87c-6.27.67-12.54,1.35-18.81.57A12.78,12.78,0,0,1,4.43,70c-.08-8.19,0-16.38,0-24.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37.58,23.55,58,67.33a1.56,1.56,0,0,1-1,2.38c-5,1.55-6.21-2.68-8-5.2L34.74,40.24a.47.47,0,0,0-.82,0c-.49.52-9,8.59-9,8.59-4.1,4.19-8.9,2.35-7.79,0l6.81-10c5.22-8-.59-6.56-.92-17.37a2.45,2.45,0,0,1,2.92-2.76s5.24,1.11,7.38,1.48C36.16,20.48,37.58,23.55,37.58,23.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.66,45.51l4.18,6.87a2,2,0,0,1-.27,2.17L26.83,69.71c-2.74,3.82-7-.43-3.72-5.77,0,0,9.55-17.59,9.86-18.23A.92.92,0,0,1,34.66,45.51Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "50.39 41.95 52 41.3 52.23 36.83 48.62 34.63 46.86 35.66 46.33 38.57 47.49 40.75 50.39 41.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38.9,46.26c-.64.34-1.58-.16-2.09-1.11h0c-.51-1-.4-2,.25-2.36l6.8-3.63c.65-.34,1.58.15,2.09,1.11h0c.52,1,.41,2-.24,2.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "48.13 32.9 49.27 23.31 49.52 32.26 48.13 32.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "50.8 32.87 56.28 24.92 52.32 32.96 50.8 32.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "53.33 34.73 61.36 29.37 54.72 35.38 53.33 34.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "54.1 37.34 63.43 39.79 54.53 38.81 54.1 37.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "53.75 40.24 61.48 46.02 53.6 41.76 53.75 40.24"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMitchatnim);
export default __webpack_public_path__ + "static/media/mitchatnim.c204c46e0d323e66c972d57879ceb739.svg";
export { ForwardRef as ReactComponent };